import React from 'react';
import { NavLink } from 'react-router-dom';
import DeferredBackground from '../Common/DeferredBackground';
import { DEFAULT_IMAGE_DELAY_MS } from '../../config/performance';

class Banner extends React.Component {
    render() {
        const delayMs =
            typeof this.props.delayMs === 'number' ? this.props.delayMs : DEFAULT_IMAGE_DELAY_MS;

        return (
            <>
                <DeferredBackground
                    className="mt-bnr-inr overlay-wraper bg-parallax bg-top-center"
                    data-stellar-background-ratio="0.5"
                    bgImage={this.props.bgimage}
                    // Slight delay helps prioritize core JS/CSS first.
                    delayMs={delayMs}
                >
                        <div className="overlay-main bg-black opacity-07" />
                        <div className="container">
                            <div className="mt-bnr-inr-entry">
                                <div className="banner-title-outer">
                                    <div className="banner-title-name">
                                        <h2 className="m-b0">{this.props.title}</h2>
                                    </div>
                                </div>
                                {/* BREADCRUMB ROW */}
                                <div>
                                    <ul className="mt-breadcrumb breadcrumb-style-2">
                                        <li><NavLink to={"./"}>Home</NavLink></li>
                                        <li>{this.props.pagename}</li>
                                    </ul>
                                </div>
                                {/* BREADCRUMB ROW END */}
                            </div>
                        </div>
                    </DeferredBackground>    
            </>
        );
    }
};

export default Banner;